import { api } from './index';
export const communeApi = { get(regionId) { const path = `/api/internal/communes?q[region_id_eq=${regionId}]`; return api({ method: 'get', url: path }).then(response => response.data.communes); } };
